import { render, staticRenderFns } from "./CardsDinamic.vue?vue&type=template&id=0087054e&scoped=true"
import script from "./CardsDinamic.vue?vue&type=script&lang=js"
export * from "./CardsDinamic.vue?vue&type=script&lang=js"
import style0 from "./CardsDinamic.vue?vue&type=style&index=0&id=0087054e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087054e",
  null
  
)

export default component.exports